import React from "react";

import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { IoIosArrowForward } from "react-icons/io";
import { BiTimer } from "react-icons/bi";
import { FaWeightHanging, FaRuler } from "react-icons/fa";

import { PALETTE } from "../../common/ThemeConstants";

export default function CardAdminExercise({
  exercise,
  primaryTypes,
  height = 100,
  editCallback,
}) {
  const description =
    exercise.description.length > 30
      ? exercise.description.slice(0, 30) + "..."
      : exercise.description;

  const getPrimaryTypeName = (id) => {
    const types = primaryTypes.filter((type) => type.id === id);
    return types.length === 0 ? "" : types[0].name;
  };
  return (
    <Card
      className="my-2 shadow-sm"
      style={{
        border: "solid 0px",
        backgroundColor: PALETTE.WHITE,
        cursor: "pointer",
        borderRadius: 20,
      }}
      onClick={() => {
        editCallback(exercise.id);
      }}
    >
      <Row className="g-0 align-items-center" style={{ width: "100%" }}>
        <Col xs={3} className="align-self-center text-start p-1">
          <Card.Img
            style={{
              objectFit: "cover",
              height: height,
              width: height,
              maxWidth: "100%",
              borderRadius: "20px 20px 20px 20px",
            }}
            src={exercise.cover}
            alt={exercise.name}
          />
        </Col>
        <Col xs={5} className="text-start" style={{ paddingLeft: "4px" }}>
          <p style={{ marginBottom: "2px" }}>{exercise.name}</p>
          <p className="mb-0 cardIconText" style={{ color: PALETTE.GRAY }}>
            {description}
          </p>
        </Col>
        <Col xs={2} className="text-center">
          {exercise.primary && exercise.primaryType && (
            <p className="mb-0">
              {getPrimaryTypeName(exercise.primaryType) === "Weight" && (
                <FaWeightHanging size={22} color={PALETTE.KINDAGRAY} />
              )}
              {getPrimaryTypeName(exercise.primaryType) === "Heart Rate" && (
                <BiTimer size={28} color={PALETTE.KINDAGRAY} />
              )}
              {getPrimaryTypeName(exercise.primaryType) === "Distance" && (
                <FaRuler size={26} color={PALETTE.KINDAGRAY} />
              )}
            </p>
          )}
        </Col>
        <Col xs={2} className="align-self-center text-end px-3">
          <IoIosArrowForward size={25} color={PALETTE.GRAY} />
        </Col>
      </Row>
    </Card>
  );
}
